<template>
  <div class="history">
    <div class="history__inner">
      <div class="history__items" ref="list" @scroll.passive="checkScroll">
        <article
          v-for="(item, i) in cards"
          :key="`item_${i}`"
          class="history__item"
          :class="`history__item_${item.color}`"
          data-animation="fadeInRight"
          :data-animation-delay="delay + (i * itemDelay)"
        >
          <BaseTitle v-if="item.title" :text="item.title" size="l" is-medium class="history__title" />
          <BaseTitle v-if="item.period" :text="item.period" is-normal class="history__period" />
          <BaseText v-if="item.text" v-html="item.text" size="xs" class="history__text" />
        </article>
      </div>
    </div>
    <div class="history__dots">
      <div
        v-for="(item, i) in cards"
        :key="`dot_${i}`"
        class="history__dot"
        :class="{ history__dot_active: i === activeIndex }"
      />
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'TheHistory',
  components: {
    BaseTitle,
    BaseText,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    itemDelay: {
      type: Number,
      default: 300,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    checkScroll() {
      const { list } = this.$refs;
      if (list) {
        const width = (list.firstChild && list.firstChild.clientWidth) || 300;
        this.activeIndex = Math.floor(list.scrollLeft / width);
      }
    },
  },
};
</script>

<style lang="stylus">
.history
  display block

  &__inner
    overflow hidden

  &__items
    display flex
    overflow-x scroll
    padding-top 0.5em
    padding-left 1.4em
    padding-bottom 2em
    margin-bottom -1em
    &:after
      content ''
      display block
      flex 0 0 1.4em

  &__item
    flex 0 0 17em
    max-width 17em
    margin-left 1.4em
    padding 1.5em
    box-shadow 0px 4px 15px rgba(0, 0, 0, 0.15)
    border-radius 1em
    &:first-child
      margin-left 0
    &_red
      background-color #FF5E5E
      color #fff
    &_yellow
      background-color #FFDB5D
      color #6F5C1B
    &_green
      background-color #9DE961
      color #44791A
    &_black
      background-color #393939
      color #D7D7D7

  &__title
    margin-bottom 0.25em
    ~/__item_red &
      color #fff
    ~/__item_black &
      color #FF5D5D

  &__period
    color inherit
    margin-bottom 1em
    ~/__item_red &
      color #FFD3D3
    ~/__item_yellow &
      color #998231
    ~/__item_green &
      color #5B952D
    ~/__item_black &
      color #A9A9A9

  &__dots
    display flex
    align-items center
    justify-content center
    margin-top 1em
    margin-bottom -1em
    +landscape()
      display none

  &__dot
    display block
    width 10px
    height @width
    background-color #DEE6FF
    border-radius @width
    margin 0 0.4em
    transition background-color 300ms
    &_active
      background-color #567DF4
</style>
